/* eslint max-len: 0 */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { func, string } from 'prop-types'
import { withTranslation } from 'react-i18next'

import { visit, click } from 'utils/tracker'

import Icon from 'components/uiElements/Icon'
import { STATE_FETCHING, STATE_DONE } from 'constants/stateTypes'
import { isEmail } from 'utils/validate'
import { getEarlyAccessSubscribeStatus } from 'models/user/selectors'
import { requestEarlyAccessSubscription } from 'models/user/actions'

import { Input } from 'components/FormElements'

require('./LearnMorePage.scss')

class LearnMorePage extends Component {
    constructor(props) {
        super(props)

        this.onSignUp = this.onSignUp.bind(this)
        this.toggleVideo = this.toggleVideo.bind(this)

        this.state = {
            earlyAccessEmail: '',
            videoOpen: false,
        }
    }

    componentDidMount() {
        visit('AboutWallspice')
    }

    onSignUp() {
        this.props.signUp(this.state.earlyAccessEmail)
    }

    toggleVideo() {
        this.setState((prevState) => ({ videoOpen: !prevState.videoOpen }))
    }

    render() {
        const { t } = this.props
        return (
            <div id="LearnMorePage">
                {this.state.videoOpen && (
                    <div className="videoContainer">
                        <Icon code="cross" onClick={this.toggleVideo} />
                        <div className="embedContainer">
                            <div className="embed">
                                <iframe
                                    title="Sugarcube video"
                                    src="//player.vimeo.com/video/402691150?playsinline=false"
                                    frameBorder="0"
                                    allow="autoplay; fullscreen"
                                    allowFullScreen
                                />
                            </div>
                        </div>
                    </div>
                )}
                <section className="intro">
                    <h1>
                        {t('learnMore.Design the perfect')}
                        <sup>{t('common.beta')}</sup>
                    </h1>
                    <p>{t('learnMore.We are always exploring')}</p>
                    <p>{t('learnMore.Please let us know')}</p>
                    <img src={`${ASSET_BUCKET}/hero/sugarcubeBeta.png`} alt={t('learnMore.alt.beta on laptop')} />
                    <div>
                        <button onClick={this.toggleVideo}>
                            <Icon code="play" /> {t('learnMore.See how it works')}
                        </button>
                    </div>
                </section>
                <section className="aboutSection capture reverse">
                    <div className="inner">
                        <div className="text">
                            <div className="textWrapper">
                                <h2>{t('learnMore.Decorate your own room')}</h2>
                                <p>{t('learnMore.Use Sugarcube mobile')}</p>
                                {this.props.earlyAccessStatus === STATE_DONE ? (
                                    <p>{t('learnMore.Thanks for your interest')}</p>
                                ) : (
                                    <div className="textWrapper">
                                        <div className="formContainer">
                                            <div className="inputContainer">
                                                <Input
                                                    className="email"
                                                    type="email"
                                                    name="earlyAccessEmail"
                                                    placeholder={t('learnMore.Please enter your email')}
                                                    value={this.state.earlyAccessEmail}
                                                    onChange={(e) =>
                                                        this.setState({ earlyAccessEmail: e.target.value })
                                                    }
                                                />
                                                <button
                                                    ref={this.signupFormButton}
                                                    onClick={this.onSignUp}
                                                    className={
                                                        this.state.earlyAccessEmail &&
                                                        !isEmail(this.state.earlyAccessEmail)
                                                            ? 'error'
                                                            : ''
                                                    }
                                                    disabled={!isEmail(this.state.earlyAccessEmail)}
                                                >
                                                    {this.props.earlyAccessStatus === STATE_FETCHING
                                                        ? t('learnMore.Signing up')
                                                        : t('learnMore.Get early access')}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="img">
                            <img
                                src={`${ASSET_BUCKET}/graphics/mobileCaptureProcess.png`}
                                alt={t('learnMore.alt.capture app')}
                            />
                        </div>
                    </div>
                </section>
                <section className="aboutSection design">
                    <div className="inner">
                        <div className="text">
                            <div className="textWrapper">
                                <h2>{t('learnMore.Decorate a room virtually')}</h2>
                                <p>{t('learnMore.Find furniture you like')}</p>
                                <Link
                                    to="/dashboard"
                                    className="notMobile"
                                    onClick={() => click('AboutWallspice.TryItNow')}
                                >
                                    <button className="tryit">{t('learnMore.Try it now')}</button>
                                </Link>
                            </div>
                        </div>
                        <div className="img">
                            <img
                                src={`${ASSET_BUCKET}/graphics/sugarcubeInAction.png`}
                                alt={t('common.alt.in action')}
                            />
                        </div>
                    </div>
                </section>
                <section className="aboutSection browse reverse">
                    <div className="inner">
                        <div className="text">
                            <div className="textWrapper">
                                <h2>{t('learnMore.Buy products you love')}</h2>
                                <p>{t('learnMore.Find products that look great')}</p>
                            </div>
                        </div>
                        <div className="img">
                            <div className="browseWrapper">
                                <img
                                    src={`${ASSET_BUCKET}/graphics/productBrowse.png`}
                                    alt={t('learnMore.alt.browsing products')}
                                />
                            </div>
                        </div>
                    </div>
                </section>
                <section className="aboutSection share">
                    <div className="inner">
                        <div className="text">
                            <div className="textWrapper">
                                <h2>{t('learnMore.Save and share ideas')}</h2>
                                <p>{t('learnMore.Save and name all of your')}</p>
                            </div>
                        </div>
                        <div className="img">
                            <img
                                src={`${ASSET_BUCKET}/graphics/shareOptions.png`}
                                alt={t('learnMore.alt.share your ideas')}
                            />
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

LearnMorePage.propTypes = {
    earlyAccessStatus: string.isRequired,
    signUp: func.isRequired,
    t: func.isRequired,
}

const mapStateToProps = (state) => ({
    earlyAccessStatus: getEarlyAccessSubscribeStatus(state),
})

const mapDispatchToProps = (dispatch) => ({
    signUp: (email) => dispatch(requestEarlyAccessSubscription(email)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LearnMorePage))
